import { AuditLogEntry } from '../../../services/audit-log/audit-log.model';
import rawEntries from './audit-log.json';

function daysAgo(n: number, offsetMinutes = 0): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  d.setMinutes(d.getMinutes() - offsetMinutes);
  return d.toISOString();
}

// JSON stores timestamps as "{{daysAgo:N:M}}" placeholders so that
// dates stay relative to "today" each time the mock server starts.
function resolveDates(entries: any[]): AuditLogEntry[] {
  return entries.map((e) => ({
    ...e,
    occurredAt: typeof e.occurredAt === 'string'
      ? e.occurredAt.replace(/\{\{daysAgo:(\d+):(\d+)\}\}/, (_: string, d: string, m: string) =>
          daysAgo(parseInt(d, 10), parseInt(m, 10))
        )
      : e.occurredAt
  }));
}

export const AUDIT_LOG_ENTRIES: AuditLogEntry[] = resolveDates(rawEntries);

function matchesFilter(entry: AuditLogEntry, params: Record<string, string>): boolean {
  if (params['from'] && entry.occurredAt < params['from']) return false;
  if (params['to'] && entry.occurredAt > params['to']) return false;
  if (params['action'] && entry.action !== params['action']) return false;
  if (params['outcome'] && entry.outcome !== params['outcome']) return false;
  if (params['actorIamId'] && !entry.actorIamId?.includes(params['actorIamId'])) return false;
  if (params['organizationId'] && entry.organizationId !== params['organizationId']) return false;
  if (params['q']) {
    const q = params['q'].toLowerCase();
    const haystack = [
      entry.actorName, entry.actorIamId, entry.action,
      entry.resourceType, entry.resourceId, entry.organizationId
    ].join(' ').toLowerCase();
    if (!haystack.includes(q)) return false;
  }
  return true;
}

export function getAuditLogPage(params: Record<string, string>): object {
  const page = parseInt(params['page'] ?? '0', 10);
  const size = parseInt(params['size'] ?? '20', 10);

  const filtered = AUDIT_LOG_ENTRIES
    .filter((e) => matchesFilter(e, params))
    .sort((a, b) => b.occurredAt.localeCompare(a.occurredAt));

  const totalElements = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalElements / size));
  const start = page * size;
  const content = filtered.slice(start, start + size);

  return {
    content,
    pageable: { pageNumber: page, pageSize: size },
    totalElements,
    totalPages,
    first: page === 0,
    last: page >= totalPages - 1
  };
}
